<template>
  <div @click="hasUserInteracted = true">
    <v-container fluid class="d-flex pa-0 fullHeight flex-column">
      <v-container fluid class="px-0">
        <div
          v-if="!payments?.length && !paymentsNext?.length && !reenrollmentPayments?.length && hasYouAreUpToDateWithPayments">
          <v-row class="my-6">
            <v-col class="text-center">
              <v-icon size="50" color="amber">mdi-creation</v-icon>
              <h2 class="mt-4">{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.no_pending_payments')
                }}
              </h2>
              <p class="mt-2">{{
                $t('modules.portalalumno.payments.paymentsStudents.view.labels.no_pending_payments_subtitle') }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col class=" d-flex flex-column justify-center align-center">
              <v-btn class="v-btn--rounded v-size--large px-6 mb-4" color="primary" width="60%" @click="toGoStudy">
                {{ $t('modules.portalalumno.payments.paymentsStudents.view.buttons.study') }}
              </v-btn>
              <v-btn class="v-btn--rounded v-size--large px-6 mb-4" color="primary" width="60%" @click="singUpSubjects">
                {{ $t('modules.portalalumno.payments.paymentsStudents.view.buttons.singUp') }}
              </v-btn>
              <v-btn class="v-btn--rounded v-size--large px-6" color="primary" width="60%" @click="toHome">
                {{ $t('modules.portalalumno.payments.paymentsStudents.view.buttons.toHome') }}
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <h4 v-else class="secondary--text mt-0 mb-6">{{
          $t('modules.portalalumno.payments.paymentsStudents.view.labels.creditcardPaid') }}</h4>

        <v-expansion-panels v-if="payments?.length" :value="0" class="expansion-payments expired mb-12" readonly flat>
          <v-expansion-panel>
            <v-expansion-panel-header class="expansion-payments__header expanded" hide-actions>
              <div class="d-flex align-center py-1">
                <v-checkbox v-model="selectedallDue" class="mt-0 mr-3 pt-0" color="primary" hide-details
                  :disabled="hasAdaptationInsurance || generatePaymentIds"></v-checkbox>
                <h3 class="flex-grow-1 font-weight-medium">{{
                  $t('modules.portalalumno.payments.paymentsStudents.view.labels.debtPayments') }}</h3>
                <div class="d-flex flex-column text-right">
                  <span>{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.total') }}</span>
                  <h3 class="font-weight-medium">{{ paymentsTotalDebt | $currency }}</h3>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(payment, index) in payments" :key="payment.id">
              <NewPaymentComplex
                :systemConfig="systemConfig"
                :canReprogram="canReprogram"
                :payment="payment"
                :seleccionDisabled="generatePaymentIds || index !== 0 && showAllPayments || index === 0 && blockAdmin || index === 0 && blockAdminNext"
                @updatepaymentmethod="updatepaymentmethod($event, index)"
                :historyDiscount="getHistoryDiscount(payment)"></NewPaymentComplex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <ReenrollmentComplex v-if="reenrollmentPayments.length" :reenrollmentPayments="reenrollmentPayments"
          :extraBenefitDiscount="extraBenefitDiscount" :systemConfig="systemConfig"
          :hasUserInteracted="hasUserInteracted"
          :hasInitalSelectionPayments="initialSelectionPayments.includes('reenrollmentPayments')"
          @updatepaymentmethod="(...args) => updatepaymentmethodReenrollment(...args)"></ReenrollmentComplex>

        <v-expansion-panels v-if="paymentsNext.length" v-model="paymentsNextOpen" class="expansion-payments mb-12" flat>
          <v-expansion-panel>
            <v-expansion-panel-header :class="['expansion-payments__header', { 'expanded': paymentsNextOpen >= 0 }]">
              <div class="d-flex align-center py-1">
                <v-checkbox v-model="selectedall" class="mt-0 mr-3 pt-0" color="primary" hide-details
                  :disabled="hasAdaptationInsurance || generatePaymentIds" @change="selectAll"></v-checkbox>
                <h3 class="flex-grow-1 font-weight-medium">{{
                  $t('modules.portalalumno.payments.paymentsStudents.view.labels.nextPayments') }}</h3>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(payment, index) in paymentsNext" :key="payment.id">
              <NewPaymentComplex
                :systemConfig="systemConfig"
                :canReprogram="canReprogram"
                :payment="payment"
                :seleccionDisabled="generatePaymentIds || index !== 0 && showAllPayments || index === 0 && blockAdmin || index === 0 && blockAdminNext"
                @updatepaymentmethod="updatepaymentmethodNext($event, index)"
                :historyDiscount="getHistoryDiscount(payment)"></NewPaymentComplex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import NewPaymentComplex from '../Components/PaymentComplex/NewPaymentComplex'
import ReenrollmentComplex from '../Components/PaymentComplex/ReenrollmentComplex'
import { $banners } from '../Services'
import moment from 'moment'

export default {
  props: {
    payments: Array,
    paymentsNext: Array,
    repayment: Object,
    systemConfig: Object,
    generatePaymentIds: { type: Boolean, default: false },
    historyDiscounts: Array,
    reenrollmentPayments: Array,
    validateExtraBenefit: Boolean,
    resumen: Object,
    extraBenefitDiscount: { type: Number, default: 0 },
    initialSelectionPayments: Array,
    hasYouAreUpToDateWithPayments: { type: Boolean, default: false }
  },
  components: {
    NewPaymentComplex,
    ReenrollmentComplex,
  },
  data() {
    return {
      selectedall: false,
      selectedallDue: false,
      blockAdminNext: false,
      blockAdmin: false,
      showAllPayments: false,
      paymentsNextOpen: 0,
      hasUserInteracted: false,
    };
  },
  computed: {

    paymentsTotalDebt() {
      return this.payments.reduce((acc, payment) => {
        return acc + payment.options.amount
      }, 0)
    },
    isAdminPayment() {
      return this.payments.find(item => item.billingProduct === this.$sisConstants('modules.products.gasto_administrativo'))
    },
    anySelected() {
      return this.payments.filter(item => item?.selected === true)
    },
    anyNextSelected() {
      return this.paymentsNext.filter(item => item?.selected === true)
    },
    canReprogram() {
      return this.repayment.available && this.payments.filter(payment => payment.repaymentAvailable === true).length >= this.repayment.installments
    },
    hasAdaptationInsurance() {
      return this.reenrollmentPayments.some(payment => payment.options.adaptationInsurance) && !this.reenrollmentPayments.every(payment => payment.options.adaptationInsurance)
    },
    hasCourseIdSelected() {
      const validProducts = [80, 81, 248]
      const allPayments = [...this.payments, ...this.paymentsNext]
      const hasValidProducts = allPayments.every(payment => validProducts.includes(payment.billingProduct))
      const hasSelectedReenrollment = allPayments.some(payment => (payment.billingProduct === 80 || payment.billingProduct === 81) && payment.selected)
      return (hasValidProducts || hasSelectedReenrollment)
    },
    hasSelectedEverytingPaymentDue() {
      return this.payments.every(payment => payment.selected)
    }
  },
  methods: {
    toGoStudy() {
      window.open(this.$countryConstants.canvas.url, '_blank')
    },
    async singUpSubjects() {
      if (this.$isIPP) {
        try {
          const banner = await $banners.find('details');
          const [, , { buttons }] = banner.data;
          const [button] = buttons;
          const { link } = button;
          if (link) {
            window.location.href = link
          }
        } catch (error) {
          //empty
        }
      }
      else {
        this.$router.replace('/academic-charge/subjects')
      }
    },

    toHome() {
      this.$router.replace('/')
    },

    getFormattedDate(date, format = 'DD-MM-YYYY') {
      return moment(date).format(format)
    },
    goToHistory() {
      if (this.$isIPP) this.$trackEvent('Pago', 'Clk_BtnVerPag_Pagos', 'PagosHistoricos') //Google Analytics - ver mis pagos IPP
      this.$router.push('/payments/history')
    },
    getHistoryDiscount({ id, reenrollmentId }) {
      const discount = this.historyDiscounts
        .find(discount => id && id === discount.accountId || reenrollmentId && reenrollmentId === discount.reenrollmentId)
      return discount
    },
    selectAll(event) {
      const every = this.payments.every(payment => payment.selected)
      if (!every) {
        this.payments.forEach(payment => {
          if (payment.billingProduct !== this.$sisConstants('modules.products.gasto_administrativo'))
            payment.selected = event
        })
      }
      this.paymentsNext.forEach(nextPayment => {
        nextPayment.selected = event
      })
      this.emitSelectedPayments()
    },
    emitSelectedPayments() {
      this.hasUserInteracted = true
      this.checkAllSelected()
      const hasSelectedReenrollment = [...this.payments, ...this.paymentsNext, ...this.reenrollmentPayments].some(
          payment => (payment.billingProduct === 80 || payment.billingProduct === 81) && payment.selected
      );

      const paymentCourse = [...this.payments, ...this.paymentsNext, ...this.reenrollmentPayments].find(
          payment => payment.billingProduct === 248
      );

      if (paymentCourse) {
          if ((hasSelectedReenrollment && this.studentData?.careerStatus?.value != 51 && !this.$isMexico) || paymentCourse.selected) {
              paymentCourse.selected = true;
              paymentCourse.options.disabled = hasSelectedReenrollment;
          } else {
              paymentCourse.selected = false;
              paymentCourse.options.disabled = false;
          }
      }

      if (this.isAdminPayment && this.isAdminPayment?.selected === true) {
        this.showAllPayments = true
      } else {
        this.showAllPayments = false
      }
      if (this.anySelected.length >= 1 && (this.isAdminPayment && !this.isAdminPayment.selected)) {
        this.blockAdmin = true
      } else {
        this.blockAdmin = false
      }
      if (this.anyNextSelected.length >= 1 && (this.isAdminPayment && !this.isAdminPayment.selected)) {
        this.blockAdminNext = true
      } else {
        this.blockAdminNext = false
      }

      const selectedPayments = [
        ...this.payments.filter(payment => payment.selected),
        ...this.paymentsNext.filter(payment => payment.selected),
        ...this.reenrollmentPayments.filter(payment => payment.selected)
      ]
      const allPayments = [...this.payments, ...this.paymentsNext, ...this.reenrollmentPayments]
      this.$emit('billingchange', { payments: allPayments, itemsToUpdate: 'all' })
      this.$emit('billingchange', { payments: selectedPayments })
    },
    updatepaymentmethod(value, index) {
      if (!this.isAdminPayment) {
        for (const [i, p] of this.payments.entries()) {
          if (new Date().toISOString().split('T')[0] > p.options.dueDate && this.payments[index].options.dueDate > p.options.dueDate)
            this.payments[i].selected = true;
        }
      }
      if (this.payments[index].independent) {
        this.payments[index].selected = value
      } else {
        if (value === true) {
          for (let i = index; i >= 0; i--) {
            if (!this.payments[i].independent && this.payments[i].groupId == this.payments[index].groupId) this.payments[i].selected = true
          }
        } else {
          for (let i = index; i <= this.payments?.length - 1; i++) {
            if (!this.payments[i].independent && this.payments[i].groupId == this.payments[index].groupId) this.payments[i].selected = false
          }
          this.paymentsNext.forEach(payment => { if (!payment.independent) payment.selected = false })
        }
      }
      this.emitSelectedPayments()
    },
    updatepaymentmethodNext(value, index) {
      for (const [i, p] of this.payments.entries()) {
        if (new Date().toISOString().split('T')[0] > p.options.dueDate && this.paymentsNext[index].options.dueDate > p.options.dueDate)
          this.payments[i].selected = true;
      }
      for (const [i, p] of this.paymentsNext.entries()) {
        if (new Date().toISOString().split('T')[0] > p.options.dueDate && this.paymentsNext[index].options.dueDate > p.options.dueDate)
          this.paymentsNext[i].selected = true;
      }
      if (this.paymentsNext[index].independent) {
        this.paymentsNext[index].selected = value
      } else {
        if (value === true) {
          for (let i = index; i >= 0; i--) {
            if (!this.paymentsNext[i].independent && this.paymentsNext[i].groupId == this.paymentsNext[index].groupId) this.paymentsNext[i].selected = true
          }
          this.payments.forEach(payment => { if (!payment.independent && payment.groupId == this.paymentsNext[index].groupId) payment.selected = true })
        } else {
          for (let i = index; i <= this.paymentsNext.length - 1; i++) {
            if (!this.paymentsNext[i].independent && this.paymentsNext[i].groupId == this.paymentsNext[index].groupId) this.paymentsNext[i].selected = false
          }
        }
      }
      this.emitSelectedPayments()
    },
    updatepaymentmethodReenrollment(value, index, selectedall) {
      //undefined para saber que no se utiliza el checkbox de seleccionar todo
      if(typeof selectedall === 'undefined'){
        if (!this.reenrollmentPayments || index < 0 || index >= this.reenrollmentPayments.length) {
          return;
        }

        for (const [i, p] of this.reenrollmentPayments.entries()) {
          if (new Date().toISOString().split('T')[0] > p.options.dueDate && this.reenrollmentPayments[index]?.options?.dueDate > p.options.dueDate)
            this.reenrollmentPayments[i].selected = true;
        }

        const currentPayment = this.reenrollmentPayments[index];
        if (currentPayment?.independent) {
          currentPayment.selected = value;
        } else {
          if (value === true) {
            // Seleccionar pagos anteriores en el mismo grupo
            for (let i = index; i >= 0; i--) {
              const payment = this.reenrollmentPayments[i];
              if (payment && !payment.independent && payment.groupId === currentPayment.groupId) {
                payment.selected = true;
              }
            }
            // Seleccionar pagos en el mismo grupo en payments
            this.payments.forEach(payment => { 
              if (!payment.independent && payment.groupId === currentPayment.groupId) {
                payment.selected = true;
              }
            });
          } else {
            // Deseleccionar pagos posteriores en el mismo grupo
            for (let i = index; i <= this.reenrollmentPayments.length - 1; i++) {
              const payment = this.reenrollmentPayments[i];
              if (payment && !payment.independent && payment.groupId === currentPayment.groupId) {
                payment.selected = false;
              }
            }
          }
        }
      }else if(!selectedall){
        //deseleccionar todos
        this.reenrollmentPayments.forEach(payment => payment.selected = selectedall)
      }else{
        //seleccionar todos
        this.reenrollmentPayments.forEach(payment => payment.selected = selectedall)
      }
      //fix para que no permita avanzar con las cuotas vencidas deseleccionadas.
      this.payments.forEach(payment => payment.selected = true)
      this.emitSelectedPayments();
    },
    checkAllSelected() {
      let selectedall = true
      let extraOffCount = 0
      let pendingCount = 0

      this.payments.forEach(payment => {
        if (!payment.selected) selectedall = false
        if (payment.options.benefitExtra || payment.options.reenrollmentExtraOff) {
          if (((payment.options.reenrollmentExtraOff || payment.groupId == 4) && this.$isTeclab) || this.$isIPP) pendingCount++
          if (payment.selected) extraOffCount++   // Grupo 1 = arancel
        }
      })
      this.paymentsNext.forEach(payment => {
        if (!payment.selected) selectedall = false
        if (payment.options.benefitExtra || payment.options.reenrollmentExtraOff) {
          if (((payment.options.reenrollmentExtraOff || payment.groupId == 4) && this.$isTeclab) || this.$isIPP) pendingCount++
          if (payment.selected) extraOffCount++   // Grupo 1 = arancel
        }
      })

      // Se define porcentaje extra de descuento solo para el pago de mas de 4 cuotas del arancel correspondiente
      this.payments.map(payment => {
        if (this.$isIPP && payment.options.reenrollmentExtraOff) {
          if (payment.options.reenrollmentExtraOff) {
            payment.options.addedExtraOff = payment.options.reenrollmentExtraOff
          }
          return payment
        }

        if (payment.options.reenrollmentExtraOff) {
          payment.options.addedExtraOff = (extraOffCount >= 2 /*&& extraOffCount == pendingCount*/) ? payment.options.reenrollmentExtraOff : 0
        } else {
          payment.options.extraOff = (extraOffCount >= 5 && extraOffCount == pendingCount) ? payment.options.benefitExtra : 0
        }
        return payment
      })
      this.paymentsNext.map(payment => {
        if (this.$isIPP) {
          if (payment.options.reenrollmentExtraOff) {
            payment.options.addedExtraOff = payment.options.reenrollmentExtraOff
          }
          return payment
        }

        if (payment.options.reenrollmentExtraOff) {
          payment.options.addedExtraOff = (extraOffCount >= 2 /*&& extraOffCount == pendingCount*/) ? payment.options.reenrollmentExtraOff : 0
        } else {
          payment.options.extraOff = (extraOffCount >= 5 && extraOffCount == pendingCount) ? payment.options.benefitExtra : 0
        }
        return payment
      })
      this.selectedall = selectedall
    }
  },
  watch: {
    reenrollmentPayments(val) {
      this.$nextTick(() => {
        if (val && val.length) this.paymentsNextOpen = undefined
        else this.paymentsNextOpen = 0
      })
    },
    generatePaymentIds(val) {
      if (val) {
        this.$nextTick(() => {
          this.selectedall = true
          this.selectAll(true)
        })
      }
    },
    selectedallDue: {
      handler(toggle) {
        if (toggle || (!toggle && this.hasSelectedEverytingPaymentDue)) {
          this.payments.forEach(payment => payment.selected = toggle)
          !toggle && (this.selectAll(false))
        }
      }
    },
    payments: {
      handler(payments) {
        if (!this.hasSelectedEverytingPaymentDue) {
          this.reenrollmentPayments.forEach(payment => payment.selected = false)
        }
        const selectedPayments = [...payments, ...this.paymentsNext, ...this.reenrollmentPayments].filter(payment => payment.selected)
        this.selectedallDue = this.hasSelectedEverytingPaymentDue
        this.$emit('billingchange', { payments: selectedPayments })
      },
      deep: true,
      immediate: true
    },
    paymentsNext: {
      handler(payments) {
        if (!this.hasUserInteracted) {
          payments.forEach(payment => {
            payment.selected = payment.billingProduct === 248 ? true : this.initialSelectionPayments.includes('paymentsNext')
          })
          const selectedPayments = [...payments, ...this.payments, ...this.reenrollmentPayments]
          .filter(payment => payment.selected)
          const every = this.payments.every(payment => payment.selected)
          if (every){
            this.selectedall = true
          }
          this.$emit('billingchange', { payments: selectedPayments })
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
.expansion-payments {
  font-family: 'DM Sans';

  &__header {
    background-color: var(--v-primary-lighten5);
    transition: border-radius 300ms ease;
    border-radius: 10px;

    &.expanded {
      border-radius: 10px 10px 0 0;
    }
  }

  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0;
    border-left: 2px solid var(--v-primary-lighten5);
    border-right: 2px solid var(--v-primary-lighten5);
    border-bottom: 2px solid var(--v-primary-lighten5);
    border-radius: 0 0 10px 10px;
  }

  &.expired {
    .expansion-payments__header {
      background-color: #FFDCDC;
    }

    ::v-deep .v-expansion-panel-content__wrap {
      padding: 0;
      border-left: 2px solid #FFDCDC;
      border-right: 2px solid #FFDCDC;
      border-bottom: 2px solid #FFDCDC;
      border-radius: 0 0 10px 10px;
    }
  }
}
</style>
